import React from 'react';

import { isArrayEmpty } from 'helpers/ArrayHelpers';
import { useAnalytics } from 'hooks/useAnalytics';

import type { IAnalyticsListProps, IProduct } from 'types';

// TODO: fix promotion type
export function useAnalyticsViewItemList(
  products: IProduct[],
  listProps: IAnalyticsListProps,
  options?: {enabled?: boolean, promotion?: {code: string, name: string}}
) {

  // Props

  const { enabled, promotion } = options || {};

  // Hooks

  const analytics = useAnalytics();

  const [triggered, setTriggered] = React.useState(false);

  // Effects

  React.useEffect(() => {
    if (enabled === false || triggered) {
      return;
    }

    if (!isArrayEmpty(products)) {
      analytics.viewItemList(
        products,
        {
          id: listProps?.analyticsListId,
          name: listProps?.analyticsListName
        },
        promotion
      );

      setTriggered(true);
    }
  }, [enabled, triggered, products, listProps, promotion]);
}
